export default __webpack_public_path__ + "static/media/cnnLogo.920ed1f4.svg";